module.exports = __webpack_public_path__ + "static/media/1019060.56215226.jpg";